module.exports = __webpack_public_path__ + "static/media/envoi_large.227306b2.png";